



















































import Vue from 'vue';

// import exhibitor, { Exhibitor } from '@/modules/exhibitor/exhibitor';
// import company, { Company } from '@/modules/exhibitor/company';

import {
  exhibitor,
  Exhibitor,
  exhibitorCompany as company,
  ExhibitorCompany as Company,
  firebase,
} from 'mostra';
// import * as firebase from '@/plugins/firebase';
// import {  } from 'mostra';

interface DataType {
  currentPage: string | (string | null)[];
  header: any;
  exhibitor: Exhibitor | null;
  company: Company | null;
  loading: boolean;
  notFound: boolean;
  owner: string | null;
}

const pageParams = ['top', 'user', 'company'];

export default Vue.extend({
  name: 'exhibitor-account-edit',
  data(): DataType {
    return {
      exhibitor: null,
      company: null,
      currentPage: 'top',
      notFound: false,
      loading: false,
      header: {
        buttons: [],
      },
      owner: null,
    };
  },
  methods: {
    async onSignOut() {
      try {
        await firebase.auth().signOut();
        window.location.href = '/';
      } catch (error: any) {
        this.$fatal(error);
      }
    },
    async fetchData() {
      if (this.exhibitor && this.company) return;
      try {
        this.loading = true;
        this.$loading(true);
        this.owner = this.$auth.cid;
        const uid = this.$auth.uid;
        const cid = this.$auth.cid;
        this.exhibitor = await exhibitor.load(uid);
        if (!cid) throw new Error('Can not find cid');
        this.company = await company.load(cid);
        if (!this.exhibitor || !this.company) {
          this.notFound = true;
          return;
        }
      } catch (error: any) {
        this.$fatal(error);
      } finally {
        this.loading = false;
        this.$loading(false);
      }
    },
    async toUpdateData() {
      try {
        if (!this.exhibitor || !this.company) return;
        this.$loading(true);
        const uid = this.$auth.uid;
        this.exhibitor = await exhibitor.save(uid, this.exhibitor);
        this.company = await company.save(uid, this.company);
        this.$success('保存しました');
      } catch (error: any) {
        this.$error('保存に失敗しました', error);
      } finally {
        this.$loading(false);
      }
    },
    setHeaderButtons(): void {
      if (this.currentPage === 'top') {
        this.header.buttons = [];
        return;
      }
      this.header.buttons = [
        {
          theme: 'primary',
          text: '保存',
          onClick: this.toUpdateData,
          withValidation: true,
        },
      ];
    },
    checkQueryParamsValid() {
      if (!(typeof this.currentPage === 'string')) {
        this.notFound = true;
        return;
      }
      const isParamsValid = pageParams.includes(this.currentPage);
      if (!isParamsValid) {
        this.notFound = true;
        return;
      }
      this.notFound = false;
    },
  },
  async beforeRouteUpdate(to, from, next) {
    next();
    await this.fetchData();
    this.currentPage = to.query.page;
    this.checkQueryParamsValid();
    this.setHeaderButtons();
  },
  async mounted() {
    await this.fetchData();
    this.currentPage = this.$route.query.page;
    this.checkQueryParamsValid();
    this.setHeaderButtons();
  },
});
